import type { EChartsOption } from 'echarts';

const TEAL = '#14b8a6';
const PALETTE = [TEAL, '#3b82f6', '#10b981', '#f59e0b', '#f43f5e', '#8b5cf6', '#06b6d4'] as const;

export function donutOption(
  _title: string,
  slices: { name: string; value: number }[],
): EChartsOption {
  return {
    color: [...PALETTE],
    tooltip: { trigger: 'item', formatter: '{b}: {c} ({d}%)' },
    legend: { bottom: 0, textStyle: { color: '#6b7280', fontSize: 11 } },
    series: [
      {
        type: 'pie',
        radius: ['42%', '68%'],
        center: ['50%', '45%'],
        avoidLabelOverlap: true,
        itemStyle: { borderRadius: 6, borderColor: '#fff', borderWidth: 2 },
        label: { show: false },
        emphasis: { label: { show: true, fontSize: 12, fontWeight: 600 } },
        data: slices.map((s) => ({ name: s.name, value: s.value })),
      },
    ],
  };
}

export function barOption(
  _title: string,
  categories: string[],
  values: number[],
  horizontal = false,
): EChartsOption {
  const ax = {
    axisLine: { lineStyle: { color: '#e5e7eb' } },
    axisLabel: { color: '#9ca3af', fontSize: 10 },
    splitLine: { lineStyle: { color: '#f3f4f6' } },
  };
  return horizontal
    ? {
        color: [TEAL],
        tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
        grid: { left: 80, right: 24, top: 16, bottom: 24 },
        xAxis: { type: 'value', ...ax },
        yAxis: { type: 'category', data: categories, ...ax },
        series: [
          {
            type: 'bar',
            data: values,
            barMaxWidth: 28,
            itemStyle: { borderRadius: [0, 6, 6, 0], color: TEAL },
          },
        ],
      }
    : {
        color: [TEAL],
        tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
        grid: { left: 48, right: 16, top: 16, bottom: 48 },
        xAxis: { type: 'category', data: categories, ...ax },
        yAxis: { type: 'value', ...ax },
        series: [
          {
            type: 'bar',
            data: values,
            barMaxWidth: 48,
            itemStyle: { borderRadius: [6, 6, 0, 0], color: TEAL },
          },
        ],
      };
}
